import { Injectable } from '@angular/core';
import { AVAILABLE_TRANSLATIONS, CURRENCIES } from '../../../assets/strings/translations';
import { TokenServiceService } from '../token-service.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {

  currentCountry = AVAILABLE_TRANSLATIONS.COL;

  constructor(private tokenService: TokenServiceService) {
  }

  setCurrentCountry() {
    const currency = this.tokenService.getAndDecodeToken().ORDER_CURRENCY;
    switch (currency) {
      case CURRENCIES.COP:
        this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
        break;
      case CURRENCIES.PEN:
        this.currentCountry = AVAILABLE_TRANSLATIONS.PER;
        break;
      case CURRENCIES.USD:
        this.currentCountry = AVAILABLE_TRANSLATIONS.ECU;
        break;
      case CURRENCIES.CRC:
        this.currentCountry = AVAILABLE_TRANSLATIONS.CRC;
        break;
      case CURRENCIES.GTQ:
        this.currentCountry = AVAILABLE_TRANSLATIONS.GTM;
        break;
      case CURRENCIES.VEF:
        this.currentCountry = AVAILABLE_TRANSLATIONS.VEN;
        break;
      default:
        this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
        break;
    }
  }
}
